import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { get } from 'lodash';
import renderInput from '../../../components/Fields/Input/Input';
import { hasMinimum } from '../../../utils/InputValidation';
import LoaderButton from '../../../components/LoaderButton/LoaderButton';
import './ManageAccountForm.scss';
import { compose } from 'redux';
import withScopedTranslations from '../../../withScopedTranslations/withScopedTranslations';

const validate = (values) => {
  const errors = {};
  const requiredMessageKey = 'required';
  const tooShortMessageKey = 'password_too_short';
  const matchMessageKey = 'passwords_must_match';
  if (!get(values, 'password')) {
    errors.password = requiredMessageKey;
  } else if (!hasMinimum(get(values, 'password'), 6)) {
    errors.password = tooShortMessageKey;
  }
  if (!get(values, 'current_password')) {
    errors.current_password = requiredMessageKey;
  } else if (!hasMinimum(get(values, 'current_password'), 6)) {
    errors.current_password = tooShortMessageKey;
  }
  if (!get(values, 'password_confirmation')) {
    errors.password_confirmation = requiredMessageKey;
  } else if (!hasMinimum(get(values, 'password_confirmation'), 6)) {
    errors.password_confirmation = tooShortMessageKey;
  } else if (get(values, 'password') !== get(values, 'password_confirmation')) {
    errors.password_confirmation = matchMessageKey;
  }
  return errors;
};

const ManageAccountForm = ({ t, handleSubmit, onSubmit, submitting, pristine, valid, }) => {
  const isButtonDisabled = pristine || (!pristine && !valid);
  return (
    <div className="row">
      <form onSubmit={handleSubmit(onSubmit)} className="col-md-9 settings__area manage-password">
        <h1 className="settings__title">{t('change_password')}</h1>
        <Field name="password" label={t('new_password')} type="password" component={renderInput} />
        <Field name="password_confirmation" label={t('repeat_password')} type="password" component={renderInput} />
        <div style={{ display: 'flex', }}>
          <Field name="current_password" label={t('current_password')} type="password" component={renderInput} />
          <span className="settings__required-text">
            {t('required_to_change')}
          </span>
        </div>
        <div className="submit-area">
          <LoaderButton
            isLoading={submitting}
            disabled={isButtonDisabled}
            label={t('change')}
          />
        </div>
      </form>
      <style jsx="true">{`
        .settings__area {
          padding-left: 30px;
          padding-top: 30px;
          padding-bottom: 30px;
          border-left: 1px solid #e5e3e8;
        }
        .settings__title {
          margin-bottom: 35px;
          font-size: 20px;
          font-weight: 900;
          color: #6c6473;
        }
        .settings__required-text {
          display: inline-block;
          font-weight: 700;
          font-style: italic;
          margin-top: 38px;
          margin-left: 25px;
        }
      `}</style>
    </div>
  );
};

ManageAccountForm.propTypes = {
  valid: PropTypes.bool.isRequired,
  pristine: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default compose(
  reduxForm({ form: 'manageAccountForm', validate, enableReinitialize: true, }),
  withScopedTranslations('dealers_settings')
)(ManageAccountForm);
